import defaultAttributes from '../defaultAttributes';

const SignalLow = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 20h.01' }],
    ['path', { d: 'M7 20v-4' }],
  ],
];

export default SignalLow;
